export default __webpack_public_path__ + "static/media/spotbusiness-screenshots.a380c788.jpg";